import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: `app.containers.ScorecardRequiredModal.title`,
    defaultMessage: 'Scorecard required',
    description:
      'Title of the modal blocking an applicant move until scorecards are submitted',
  },
  introAllEvaluators: {
    id: `app.containers.ScorecardRequiredModal.introAllEvaluators`,
    defaultMessage:
      '{stageName} requires all assigned scorecards to be submitted before {applicantName} can be advanced or rejected. {submittedCount} of {requiredCount} submitted so far.',
    description:
      'Blocking modal copy when the stage requires every assigned evaluator to submit',
  },
  introAtLeastOne: {
    id: `app.containers.ScorecardRequiredModal.introAtLeastOne`,
    defaultMessage:
      '{stageName} requires at least one scorecard to be submitted before {applicantName} can be advanced or rejected. No scorecards submitted so far.',
    description:
      'Blocking modal copy when the stage requires at least one submitted scorecard and none exist',
  },
  introSpecificNumber: {
    id: `app.containers.ScorecardRequiredModal.introSpecificNumber`,
    defaultMessage:
      '{stageName} requires at least {requiredCount} scorecards to be submitted before {applicantName} can be advanced or rejected. {submittedCount} of {requiredCount} scorecards submitted so far.',
    description:
      'Blocking modal copy when the stage requires a specific number of submitted scorecards',
  },
  introAllEvaluatorsPlural: {
    id: `app.containers.ScorecardRequiredModal.introAllEvaluatorsPlural`,
    defaultMessage:
      '{stageName} requires all assigned scorecards to be submitted before these applicants can be advanced or rejected.',
    description:
      'Blocking modal copy for a bulk action when the stage requires every assigned evaluator to submit',
  },
  introAtLeastOnePlural: {
    id: `app.containers.ScorecardRequiredModal.introAtLeastOnePlural`,
    defaultMessage:
      '{stageName} requires at least one scorecard to be submitted before these applicants can be advanced or rejected.',
    description:
      'Blocking modal copy for a bulk action when the stage requires at least one submitted scorecard',
  },
  introSpecificNumberPlural: {
    id: `app.containers.ScorecardRequiredModal.introSpecificNumberPlural`,
    defaultMessage:
      '{stageName} requires at least {requiredCount} scorecards to be submitted before these applicants can be advanced or rejected.',
    description:
      'Blocking modal copy for a bulk action when the stage requires a specific number of submitted scorecards',
  },
  applicantColumn: {
    id: `app.containers.ScorecardRequiredModal.applicantColumn`,
    defaultMessage: 'Applicant',
    description:
      'Column header naming the blocked applicant, shown only on bulk refusals',
  },
  evaluatorColumn: {
    id: `app.containers.ScorecardRequiredModal.evaluatorColumn`,
    defaultMessage: 'Evaluator',
    description: 'Column header for the assigned evaluator name',
  },
  scorecardColumn: {
    id: `app.containers.ScorecardRequiredModal.scorecardColumn`,
    defaultMessage: 'Scorecard',
    description: 'Column header for the scorecard name',
  },
  statusColumn: {
    id: `app.containers.ScorecardRequiredModal.statusColumn`,
    defaultMessage: 'Status',
    description: "Column header for the evaluator's scorecard status",
  },
  sendReminder: {
    id: `app.containers.ScorecardRequiredModal.sendReminder`,
    defaultMessage: 'Send reminder',
    description: 'Button that emails a reminder to one assigned evaluator',
  },
  reminderSent: {
    id: `app.containers.ScorecardRequiredModal.reminderSent`,
    defaultMessage: 'Sent ✅',
    description:
      'Replaces the Send reminder button after the reminder email is sent',
  },
  fillOutScorecard: {
    id: `app.containers.ScorecardRequiredModal.fillOutScorecard`,
    defaultMessage: 'Fill out scorecard',
    description:
      "Button on the signed-in user's own pending evaluator row that opens their scorecard form",
  },
  noEvaluatorsAssigned: {
    id: `app.containers.ScorecardRequiredModal.noEvaluatorsAssigned`,
    defaultMessage:
      'No evaluators are assigned to the required scorecards yet.',
    description:
      'Shown instead of the evaluator table when the stage has scorecards but nobody assigned',
  },
  inviteEvaluatorsHint: {
    id: `app.containers.ScorecardRequiredModal.inviteEvaluatorsHint`,
    defaultMessage:
      'Invite evaluators or submit scorecards from the scorecard status label on the applicant.',
    description:
      'Next step shown when a pending evaluator in the blocking modal has no reminder or fill-out action',
  },
  reminderFailed: {
    id: `app.containers.ScorecardRequiredModal.reminderFailed`,
    defaultMessage: "We couldn't send the reminder. Try again.",
    description: 'Error shown when sending an evaluator reminder fails',
  },
  cappedApplicants: {
    id: `app.containers.ScorecardRequiredModal.cappedApplicants`,
    defaultMessage:
      'Showing the first {shownCount} of {blockedCount} blocked applicants',
    description:
      'Note under the evaluator table when a bulk refusal blocks more applicants than the modal lists',
  },
});
